import React from 'react'
import { useStrategyEdit } from './hooks'
import {
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CForm,
  CFormInput,
  CFormLabel,
  CFormSelect,
  CFormTextarea,
  CRow,
} from '@coreui/react-pro'
import { setStrategyEdit, submitEditStrategy } from './model'
import { Image } from 'antd'

type Props = {
  className?: string
}

export const StrategyEdit = ({ className }: Props) => {
  const { strategyEdit, loading } = useStrategyEdit()
  const {
    id,
    title,
    description,
    commission,
    percentCommission,
    numAdditionalInvestors,
  } = strategyEdit

  const handleChange = (
    event: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >,
  ) => {
    setStrategyEdit({
      ...strategyEdit,
      [event.target.name]: event.target.value,
    })
  }

  return (
    <CCol xs={12} className={className}>
      <CCard className="mb-4">
        <CCardHeader>
          <strong>Edit Strategy {id}</strong>
        </CCardHeader>
        <CCardBody>
          <CForm>
            <CRow>
              <CCol xs={12}>
                <div className="mb-3">
                  <CFormLabel htmlFor="title">Title</CFormLabel>
                  <CFormInput
                    type="text"
                    name="title"
                    placeholder="Enter title"
                    value={title}
                    onChange={handleChange}
                  />
                </div>
              </CCol>
            </CRow>
            <CRow>
              <CCol xs={12}>
                <div className="mb-3">
                  <CFormLabel htmlFor="description">Description</CFormLabel>
                  <CFormTextarea
                    name="description"
                    rows={3}
                    placeholder="Enter description"
                    value={description}
                    onChange={handleChange}
                  />
                </div>
              </CCol>
            </CRow>
            <CRow>
              <CCol xs={12}>
                <div className="mb-3">
                  <CFormLabel htmlFor="description">
                    Number of investors
                  </CFormLabel>
                  <CFormInput
                    type="number"
                    name="numAdditionalInvestors"
                    placeholder="Number of investors"
                    value={numAdditionalInvestors}
                    onChange={handleChange}
                  />
                </div>
              </CCol>
            </CRow>
            <CRow>
              <CCol xs={12}>
                <div className="mb-3">
                  <CFormLabel htmlFor="commission">Commission</CFormLabel>
                  <CFormInput
                    disabled
                    type="text"
                    name="commission"
                    placeholder="Enter commission"
                    value={commission}
                    onChange={handleChange}
                  />
                </div>
              </CCol>
            </CRow>
            <CRow>
              <CCol xs={12}>
                <div className="mb-3">
                  <CFormLabel htmlFor="percentCommission">
                    Commission %
                  </CFormLabel>
                  <CFormInput
                    disabled
                    type="text"
                    name="percentCommission"
                    placeholder="Enter commission %"
                    value={Number(percentCommission) * 100}
                    onChange={handleChange}
                  />
                </div>
              </CCol>
            </CRow>
            <CButton
              className="mb-3"
              disabled={loading}
              onClick={() => {
                if (window.confirm('Are you sure?')) {
                  submitEditStrategy({
                    ...strategyEdit,
                    numAdditionalInvestors: Number(
                      strategyEdit.numAdditionalInvestors,
                    ),
                  })
                }
              }}
            >
              {loading && (
                <span className="spinner-border spinner-border-sm"></span>
              )}
              Save
            </CButton>
          </CForm>
        </CCardBody>
      </CCard>
    </CCol>
  )
}

export const StrategyEditDetail = () => (
  <div>
    <CRow>
      <StrategyEdit />
    </CRow>
  </div>
)
